<template>
  <div class='BannerList'>
    <div class="nome">
      {{ data.link }}
    </div>
    <div class="img">
      <img v-if="data.img.length" @click="$refs.in.click()" :src="api + data.img">
      <img-icon @click="$refs.in.click()" v-if="!data.img.length" :options="{ width: '35px', height: '25px', color: '#CCCCCC', action: true }"/>
    </div>
    <div class="btn">
      <delete-icon @click="$emit('del', data.id)"/>
    </div>
    <input ref="in" v-show="false" type="file" @change="inFile"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DeleteIcon from '../Icons/DeleteIcon'
import ImgIcon from '../Icons/ImgIcon'
import api from '@/mixins/api'
import compressImage from '@/mixins/compressImage'
export default {
  name: 'BannerList',
  components: { DeleteIcon, ImgIcon },
  props: ['data'],
  mixins: [api, compressImage],
  methods: {
    ...mapActions(['_UpdateBannerImg']),
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        this._UpdateBannerImg({ id: this.data.id, img: await this.compressImage(reader.result), filename: file.name })
          .then(() => {
            this.$emit('updateimg', this.data.id + file.name)
          })
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  }
}
</script>

<style scoped>
.BannerList {
  display: flex;
  padding-top: 2%;
}

.nome {
  width: 70%;
  text-align: left;
  padding: 2%;
  border-radius: 5px;
  border: thin solid #CCCCCC;
  overflow: hidden;
}

.img {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
}


img {
  width: 30px;
  height: 30px;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
}
</style>
